import type { useTranslations } from 'next-intl';

type Translate = ReturnType<typeof useTranslations<'auth.register'>>;

export type RegisterFieldKey = 'full_name' | 'email' | 'password';

export function getRegisterFieldError(
  t: Translate,
  field: RegisterFieldKey,
  code: string | undefined,
): string | undefined {
  if (!code) return undefined;
  if (field === 'full_name') {
    if (code === 'required') return t('errors.full_name.required');
    if (code === 'too_short') return t('errors.full_name.too_short');
  }
  if (field === 'email') {
    if (code === 'required') return t('errors.email.required');
    if (code === 'invalid') return t('errors.email.invalid');
  }
  if (field === 'password') {
    if (code === 'required') return t('errors.password.required');
    if (code === 'too_short') return t('errors.password.too_short');
    if (code === 'too_long') return t('errors.password.too_long');
    if (code === 'missing_uppercase') return t('errors.password.missing_uppercase');
    if (code === 'missing_digit') return t('errors.password.missing_digit');
    if (code === 'missing_special') return t('errors.password.missing_special');
  }
  return undefined;
}

export function getRegisterApiError(t: Translate, code: string): string {
  switch (code) {
    case 'email_taken':
      return t('errors.api.email_taken');
    case 'validation':
      return t('errors.api.validation');
    case 'rate_limited':
      return t('errors.api.rate_limited');
    default:
      return t('errors.api.server_error');
  }
}
